import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  questions: [],
  question: false,
  loading: false,
  formLoading: false,
  exportLoading: false,
  error: false,
  success: false,
  userQuestion: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Forum/index.js